// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

export const getColorStatus = (status) => {
  if (status === 3) {
    return 'status-delivered';
  } else {
    return 'status-prepare-deliver';
  }
};
